import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    sidebar: true
};

const sidebarSlice = createSlice({
    name: "sidebarSlice",
    initialState,
    reducers: {
        toggleSidebar: (state, action) => {
            state.sidebar = !state.sidebar;
            return state;
        }
    }
})

export const { toggleSidebar } = sidebarSlice.actions;
export default sidebarSlice;